export var ContextMode;
(function (ContextMode) {
    ContextMode[ContextMode["AUTO"] = 0] = "AUTO";
    ContextMode[ContextMode["WEBGL"] = 1] = "WEBGL";
    ContextMode[ContextMode["FLASH"] = 2] = "FLASH";
    ContextMode[ContextMode["GLES"] = 3] = "GLES";
    ContextMode[ContextMode["NATIVE"] = 4] = "NATIVE";
    ContextMode[ContextMode["SOFTWARE"] = 5] = "SOFTWARE";
})(ContextMode || (ContextMode = {}));
